import {
  addSaveSearch,
  fetchSaveSearch,
  removeSaveSearchApi,
} from "api/saveSearch";
import React, { createContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchMapProperties } from "api/property";
import { createFiltersFromUrl } from "pages/Research/filters";

export const SaveSearchContext = createContext();

export const SaveSearchProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [isFetchingSaveSearch, setIsFetchingSaveSearch] = useState(false);
  const [error, setError] = useState(null);
  const [saveSearches, setSaveSearches] = useState([]);

  const fetchSaveSearches = async (nextUrl = null) => {
    setIsFetchingSaveSearch(true);
    setError(null);
    try {
      const fetchedSearches = await fetchSaveSearch(nextUrl);

      const results = fetchedSearches.results || [];

      const searchesWithProperties = await Promise.all(
        results.map(async (search) => {
          const filters = createFiltersFromUrl(search.url);
          const properties = await fetchAllSavedSearchProperties(filters);
          return { ...search, properties };
        })
      );

      if (nextUrl) {
        setSaveSearches((prevSearches) => ({
          results: [...prevSearches.results, ...searchesWithProperties],
          pagination: fetchedSearches.pagination,
        }));
      } else {
        setSaveSearches({
          results: searchesWithProperties,
          pagination: fetchedSearches.pagination,
        });
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsFetchingSaveSearch(false);
    }
  };

  // Get all save searched properties
  const fetchAllSavedSearchProperties = async (filters) => {
    try {
      const result = await fetchMapProperties(filters);
      return result;
    } catch (err) {
      console.log(err.message);
      return [];
    }
  };

  const saveSearch = async (searchData) => {
    setLoading(true);
    setError(null);
    try {
      await addSaveSearch(searchData);
      toast.success(
        `La ricerca ${searchData.searchName} è stata salvata con successo`
      );
    } catch (err) {
      toast.error("Questa ricerca è stata già salvata nella dashboard");
    } finally {
      setLoading(false);
    }
  };

  const removeSaveSearch = async (id) => {
    setLoading(true);
    try {
      await removeSaveSearchApi(id);

      // Update the state
      setSaveSearches((prevSearches) => ({
        ...prevSearches,
        results: prevSearches.results.filter((search) => search._id !== id),
      }));
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SaveSearchContext.Provider
      value={{
        saveSearches,
        saveSearch,
        removeSaveSearch,
        loading,
        error,
        fetchSaveSearches,
        isFetchingSaveSearch,
      }}
    >
      {children}
    </SaveSearchContext.Provider>
  );
};
